import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import { getHostHistoryRows } from "./checkRowsHostData";

// Mode can be either Table or card, entityData is the data of the entity
// The view should support both view modes
const HostHistoryView = ({ entityData }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    setRows(getHostHistoryRows(entityData));
  }, [entityData]);

  // Categorize rows by type
  const categorizedRows = {
    lastSeen: rows.filter((row) => row?.last_seen),
    creationDate: rows.filter((row) => row?.first_seen),
    lastUpdated: rows.filter((row) => row?.last_updated),
    lastEnrollment: rows.filter((row) => row?.last_enrollment),
    lastScan: rows.filter((row) => row?.last_scan),
    purchaseDate: rows.filter((row) => row?.purchase_date),
  };

  return (
    rows.length > 0 && (
      <Box display={"flex"} gap={2} flexDirection={"column"}>
        {/* Last seen */}
        {categorizedRows.lastSeen.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Last Seen</Typography>
            </Box>
            <Box ml={3} display={"flex"} flexDirection={"column"} gap={1}>
              {categorizedRows.lastSeen.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box display={"flex"} gap={1}>
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.last_seen}
                  onlyDate={true}
                />
              ))}
            </Box>
          </Box>
        )}
        {/* Creation date */}
        {categorizedRows.creationDate.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Creation Date</Typography>
            </Box>
            <Box ml={3} display={"flex"} flexDirection={"column"} gap={1}>
              {categorizedRows.creationDate.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box display={"flex"} gap={1}>
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.first_seen}
                />
              ))}
            </Box>
          </Box>
        )}
        {/* Last updated */}
        {categorizedRows.lastUpdated.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Last Updated</Typography>
            </Box>
            <Box ml={3} display={"flex"} flexDirection={"column"} gap={1}>
              {categorizedRows.lastUpdated.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box display={"flex"} gap={1}>
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.last_updated}
                />
              ))}
            </Box>
          </Box>
        )}
        {/* Last Enrollment Date */}
        {categorizedRows.lastEnrollment.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>
                Last Enrollment Date
              </Typography>
            </Box>
            <Box ml={3} display={"flex"} flexDirection={"column"} gap={1}>
              {categorizedRows.lastEnrollment.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box display={"flex"} gap={1}>
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.last_enrollment}
                />
              ))}
            </Box>
          </Box>
        )}
        {/* Last Scan Date */}
        {categorizedRows.lastScan.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Last Scan Date</Typography>
            </Box>
            <Box ml={3} display={"flex"} flexDirection={"column"} gap={1}>
              {categorizedRows.lastScan.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box display={"flex"} gap={1}>
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.last_scan}
                />
              ))}
            </Box>
          </Box>
        )}
        {/* Purchase Date */}
        {categorizedRows.purchaseDate.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Purchase Date</Typography>
            </Box>
            <Box ml={3} display={"flex"} flexDirection={"column"} gap={1}>
              {categorizedRows.purchaseDate.map((row) => (
                <TextIntegrationStyle
                  key={row.id}
                  title={
                    <Box display={"flex"} gap={1}>
                      <IntegrationImage
                        name={row.source}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={row.purchase_date}
                />
              ))}
            </Box>
          </Box>
        )}
      </Box>
    )
  );
};

export default HostHistoryView;
